/** Current site hostname in the browser (org is resolved from URL, not env). */
export function getAppDomainHost() {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    return window.location.hostname.trim().toLowerCase();
  }
  return '';
}

function domainIncludes(...fragments) {
  const host = getAppDomainHost();
  if (!host) return false;
  return fragments.some((fragment) => {
    const needle = String(fragment).trim().toLowerCase();
    return host === needle || host.endsWith(`.${needle}`) || host.includes(needle);
  });
}

export function isTpiDomain() {
  return domainIncludes('lms.tpi.sg', 'tpi.sg');
}

export function isNxgenVarsityDomain() {
  return domainIncludes('lms.nxgenvarsity.com', 'nxgenvarsity.com');
}

export function isCreatorFoundationDomain() {
  return domainIncludes('lms.creatorfoundation.in', 'creatorfoundation.in');
}

export function getDefaultCourseCurrency() {
  if (isTpiDomain()) return 'SGD';
  return 'INR';
}
